












import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { mapGetters } from "vuex"
import Question from "../models/Question"
import { State, Getter, Action, Mutation } from "../store-helper"
import markdownParser from "../../../helpers/markdown-parser"
import SkillPreviewComponent from './SkillPreviewComponent.vue'

@Component({
  components: {
    SkillPreviewComponent,
  }
})

export default class ExplanationPreviewComponent extends Vue {
  @Prop() groupQuestions: Question[]

  getContent(question): string {
    return markdownParser(question.description)
  }
}
